import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png"; // <-- Add your logo here
import PageLoader from "../../components/PageLoader";

export default function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // const handleLogin = async (e) => {
    
  //   e.preventDefault();

  //   if (!email || !password) {
  //     setError("Email and Password are required.");
  //     return;
  //   }

  //   setLoading(true);
  //   setError("");

  //   try {
  //     const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/login`, {
  //       email,
  //       password,
  //     });
  //     if(response.status == 200){
  //     const roleId = response.data.user.role;
  //     const empId = response.data.user.empid;
  //     const email = response.data.user.email;
  //     const userName = response.data.user.userName;

  //     let role=null;
  //     if(roleId.toString()=="1"){
  //       role = "Admin";
  //     }
  //     else
  //     {
  //       role="Employee";
  //     }

  //     localStorage.setItem("role", role);
  //     localStorage.setItem("empId", empId);
  //     localStorage.setItem("email", email);
  //     localStorage.setItem("userName", userName);
  //     navigate("/v4");
  //     }
  //   } catch (err) {
  //     console.log("error",err)
  //   } finally {
  //     setLoading(false);
  //     setError("Invalid credentials. Try again.");
  //   }
  // };

  const handleLogin = async (e) => {
  e.preventDefault();

  if (!email || !password) {
    setError("Email and Password are required.");
    return;
  }

  setLoading(true);
  setError("");

  try {
    const response = await axios.post(
      `https://api.autotronicsuk.com/api/login`,
      { email, password }
    );

    if (response.status === 200) {
      const user = response.data.user;

      const role = user.role.toString() === "1" ? "Admin" : "Employee";

      // Save data to localStorage
      localStorage.setItem("role", role);
      localStorage.setItem("empId", user.empid);
      localStorage.setItem("email", user.email);
      localStorage.setItem("userName", user.userName);

      // VERY IMPORTANT — required for ProtectedRoute
      localStorage.setItem("isLoggedIn", "true");

      navigate("/"); // redirect works now!
    }
  } catch (err) {
    console.log("error", err);
    setError("Invalid credentials. Try again.");
  } finally {
    setLoading(false);
  }
};

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "100vh", backgroundColor: "#f2f2f2" }}
    >
      {/* full screen loader while authenticating */}
      {loading && <PageLoader message="Logging in..." />}

      <link
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css"
  rel="stylesheet"
/>

      <div
        className="p-4 shadow rounded"
        style={{ width: "350px", backgroundColor: "#fff" }}
      >
        {/* ------ Logo ------ */}
        <div className="text-center mb-3">
          <img
            src={logo}
            alt="Company Logo"
            style={{ width: "220px", height: "auto" }}
          />
        </div>

        {/*<h3 className="text-center mb-4">Login</h3>*/}

        {error && (
          <div className="alert alert-danger py-2 text-center">{error}</div>
        )}

        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control p-2"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="mb-3 position-relative">
            <label className="form-label">Password</label>

            <input
              type={showPassword ? "text" : "password"}
              className="form-control p-2"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <span
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute",
                right: "10px",
                top: "38px",
                cursor: "pointer",
                color: "#555",
              }}
            >
              <i className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
            </span>
          </div>

          <button
            type="submit"
            className="btn w-100 text-white fw-semibold"
            style={{ backgroundColor: "#28B463" }}
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}
